// نشان وضعیت اتصال در Header (IA §4 بند ۸؛ ARD-offline §۲): برخط، آفلاین (با شمار عملیات در انتظار) یا در حال همگام‌سازی؛ کلیک ← میز آفلاین.
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import Chip from '@mui/material/Chip';
import { useTranslation } from '@phoenix/i18n';
import { Link as RouterLink } from 'react-router';
import { useOffline } from './OfflineProvider';

export const OFFLINE_DESK_PATH = '/offline';
export const SYNC_CONFLICTS_PATH = '/offline/conflicts';

export function ConnectionIndicator() {
  const { t } = useTranslation('bil');
  const offline = useOffline();
  const state = offline.status === 'offline' ? 'offline' : offline.syncing ? 'syncing' : 'online';
  const label =
    state === 'offline'
      ? t('bil:offline.indicator.offline', { count: offline.pendingCount })
      : state === 'syncing'
        ? t('bil:offline.indicator.syncing')
        : offline.pendingCount > 0
          ? t('bil:offline.indicator.pending', { count: offline.pendingCount })
          : t('bil:offline.indicator.online');
  const icon =
    state === 'offline' ? <CloudOffOutlinedIcon /> : state === 'syncing' ? <CloudSyncOutlinedIcon /> : <CloudDoneOutlinedIcon />;
  return (
    <Chip
      component={RouterLink}
      to={OFFLINE_DESK_PATH}
      clickable
      size="small"
      variant={state === 'online' ? 'outlined' : 'filled'}
      color={state === 'offline' ? 'warning' : state === 'syncing' ? 'info' : 'success'}
      icon={icon}
      label={label}
      data-testid="connection-indicator"
      data-state={state}
      data-pending={offline.pendingCount}
    />
  );
}
